import RightPanelCard from "components/Common/RightPanelCard";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useEffect, useState } from "react";
import { getJobLogsByID } from "actions/job";
import { JOB_STATUS } from "components/Common/constants";
import { WORK_ORDER, SMALL_CASE_WORK_ORDER } from "components/Common/constants";
import { toTitleCase } from "components/Common/commonFunctions";

// Below function is used to view logs of job
export function JobLogs({ isOpen, handleClose, decodedId, activeTab }) {
  const [jobLogs, setJobLogs] = useState([]);
  const [showAlternative, setShowAlternative] = useState({
    loader: false,
    error: "",
    noRecords: false,
  });

  useEffect(() => {
    if (decodedId && activeTab === "overview" && isOpen) {
      jobLogsDetails(decodedId);
    }
  }, [decodedId, activeTab, isOpen]);

  const jobLogsDetails = async (id) => {
    try {
      setShowAlternative({ loader: true, error: false });
      const res = await getJobLogsByID(id);

      if (res.code === 200) {
        const jobLogsRes = res?.data?.JobLog || [];
        setJobLogs(jobLogsRes);
        setShowAlternative({
          loader: false,
          error: false,
          noRecords: res.data.totalRecords === 0,
        });
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Failed to load timeline!";
        setShowAlternative({ loader: false, error: message, noRecords: false });
      }
    } catch (error) {
      setShowAlternative({
        loader: false,
        error: error || "Failed to load timeline!",
        noRecords: false,
      });
    }
  };

  return (
    <RightPanelCard isOpen={isOpen} onClose={handleClose}>
      <Card className="location-card mb-0">
        <CardHeader
          className="d-flex align-items-center justify-content-between"
          tag="h4"
        >
          {WORK_ORDER} Logs
          <i className="fa fa-close text-muted pointer" onClick={handleClose} />
        </CardHeader>
        <hr />
        {showAlternative.loader ? (
          <div className="loaderContainer">
            <i className="fa fa-spinner fa-spin fa-2xl loader" />
          </div>
        ) : showAlternative.error ? (
          <>
            <div className="loaderContainer">{showAlternative.error}</div>
          </>
        ) : showAlternative.noRecords ? (
          <div className="loaderContainer text-muted d-flex flex-column">
            <h4 className="text-muted">No {SMALL_CASE_WORK_ORDER} logs are Available</h4>
            <span className="text-danger">{showAlternative.error}</span>
          </div>
        ) : (
          <CardBody className="scrollbar-inner overflow-auto">
            <div className="timeline-container">
              <div className="timeline-line" />
              {jobLogs.map((log) => (
                <div className="timeline-item" key={log.ID}>
                  <div className="timeline-dot" />
                  <div className="timeline-card">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="name">
                        <span className="text-muted mr-1">Action By: </span>
                        {toTitleCase(log.actionBy.fullName)}
                      </div>
                      <div className="time">{log.date}</div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="message">{toTitleCase(log.operationRemark)}</div>
                      <div className="status"><span className="text-muted mr-1">Status: </span>
                        {JOB_STATUS[log.status]?.label ||
                          log.status}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardBody>
        )}
      </Card>
    </RightPanelCard>
  );
}
